import React from 'react';
import styled from 'styled-components';
import Slider from '../GraphContents/Slider';

const Container = styled.div`
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
`;

const CommentsContainer = styled.div`
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 8px;
  font-size: large;
`;

const TurnoverContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  text-align: center;
  font-size: medium;
  background-color: ${props =>
    props.turnover == 'Medio Alto' ? '#f0abab' : ''};
`;

export default function HistoryItem(props) {
  const { event } = props;

  const {
    title,
    comments,
    obs,
    evasionLabel,
    health,
    archetype,
    happiness
  } = event;

  return (
    <Container>
      <h4>{title}</h4>
      <h6>Felicidade: </h6>
      <Slider color="#33415c" fontColor="#fff" value={happiness} />
      <h6>Cultura: </h6>
      <Slider color="#33415c" fontColor="#fff" value={archetype} />

      <br />
      {comments ? (
        <CommentsContainer>
          {' '}
          <b>Comentários {event.name} : </b> {comments}
        </CommentsContainer>
      ) : (
        ''
      )}
      <br />
      {obs ? (
        <CommentsContainer>
          {' '}
          <b>Comentários SHO:</b> {obs}
        </CommentsContainer>
      ) : (
        ''
      )}
      <br />

      <TurnoverContainer turnover={evasionLabel}>
        <b>Risco de turnover: </b>
        {evasionLabel}
      </TurnoverContainer>
    </Container>
  );
}
